import { ArrowUpRight } from 'lucide-react'
import { creator } from '@/config/creator'
import SocialLinks from './SocialLinks'

export default function FounderFooter() {
  return (
    <footer className="border-t border-border bg-secondary/40 py-12 md:py-16">
      <div className="creator-container">
        <div className="grid items-start gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="/" className="creator-display inline-flex min-h-11 items-center gap-3 text-3xl">{creator.name}<span aria-hidden="true" className="h-3 w-3 rounded-full bg-primary" /></a>
            <p className="mt-4 max-w-sm text-base leading-relaxed text-muted-foreground">I’m building the future of software.<br />With San Francisco energy and Sicilian roots.</p>
            <a href={creator.companyUrl} target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex min-h-11 items-center gap-2 text-sm font-semibold hover:text-primary">Explore Coderblock.ai<ArrowUpRight aria-hidden="true" size={16} /></a>
          </div>
          <div className="md:col-span-7 md:justify-self-end">
            <p className="creator-label mb-4">Keep a tab open</p>
            <SocialLinks />
            <a href={creator.meetingUrl} target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex min-h-11 items-center gap-2 font-semibold text-primary hover:underline">Book a conversation<ArrowUpRight aria-hidden="true" size={17} /></a>
          </div>
        </div>
        <div className="mt-10 flex flex-wrap items-center justify-between gap-4 border-t border-border pt-6 text-xs leading-relaxed text-muted-foreground">
          <p>© {new Date().getFullYear()} {creator.name}</p>
          <p>SF HQ · 201 Spear St <span aria-hidden="true" className="mx-2">/</span> Palermo roots</p>
          <a href="#main-content" className="inline-flex min-h-11 items-center gap-2 font-semibold text-foreground hover:text-primary">Back to top<ArrowUpRight aria-hidden="true" size={15} /></a>
        </div>
      </div>
    </footer>
  )
}
